export const acceptedImageTypes = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/bmp',
  'image/svg+xml',
  'image/webp',
];

export enum Status {
  Pending,
  Uploading,
  Uploaded,
  Confirmed,
  Failed,
}
